<template>
     <div class="card-message">
        <div>
            <br>
            <img :src= "creatorImage" alt="" height="20" width="20" class="float-left rounded-circle shadow-sm">
            <div class="username float-left ml-1 font-size-11">
               {{data.user.name}} {{data.user.lname ? data.user.lname : ''}}
            </div>
            <br> 
            <br>
            <div class="message-time float-left   font-size-11">
			  {{data.message}}  
                <a v-if="data.file" target="_blank" :href="data.file" download class="text-kllaar">
                    / <i class="fas fa-paperclip text-primary"></i> Archivo adjunto
                </a>
                - <em>{{data.created_at}}</em>

            </div>
            <br>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        data: Object
    },
    data() {
        return {
			defaultImage: require('@/assets/profile/user_empty.png'),
        }
    },
	computed: {
		creatorImage () {
			return this.data.user.avatar ? this.data.user.avatar : this.defaultImage
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/#pages/messages/components/MessageItem.vue